<app-pesquisa-base #modal titulo="Meus Atendimentos" subtitulo="Encontre o atendimento desejado na lista e clique duas vezes na linha correspondente para abri-lo." 
    (registroSelecionado)="selecionado($event)">
    <ng-template appFiltroPesquisa>
        <form [formGroup]='modelo' [ngClass]="{'submitted': submetido}">
            <div class="filtro-container">
                <label class="filtro-titulo">
                    <i class="fal fa-filter"></i>Filtros
                </label>

                <div class="filtro-campos">
                    <div class="filtro-campo-auto">
                        <ejs-checkbox label='Apenas atendimentos com agendamento vinculado.' formControlName="apenasComAgendamentoVinculado"></ejs-checkbox>
                    </div>
                </div>
                
                <div class="filtro-campos">
                    <div class="filtro-campo" required>
                        <ejs-daterangepicker [showClearButton]="false" [strictMode]="false"            
                            [placeholder]="'Período'" [floatLabelType]="'Always'" 
                            [presets]="presets.defaults"
                            formControlName="datas"></ejs-daterangepicker>
                        <app-error-handler [control]="modelo.get('datas')"
                            [submitted]='submetido' [errorType]="'required'">
                        </app-error-handler>
                    </div>
                </div>
                
                <div class="filtro-acao">
                    <input type="button" appBotaoFocadoFiltroPesquisa ejs-button iconCss="fas fa-search" value="Atualizar" 
                        (click)="atualizarClick()" cssClass="e-primary filtro-botao-principal"/>
                    <input type="button" ejs-button iconCss="fas fa-calendar-day" value="Apenas Hoje" 
                        (click)="preencherDataHoje()" cssClass="e-info filtro-botao-secundario"/>
                </div>

                <div class="filtro-campos" *ngIf="false">
                    <div class="filtro-campo-auto">
                        <ejs-checkbox [label]="'Apresentar mais campos pessoais.'" [(checked)]="moreFields"></ejs-checkbox>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
    <ng-template appConteudoPesquisa>

        <ejs-contextmenu #contextmenu [items]='contextMenuItems' (select)='contextMenuClick($event)'></ejs-contextmenu>

        <ejs-grid #grid appGridPesquisa 
            [dataSource]="registros" 
            [enableVirtualization]='false' 
            [pageSettings]='{ pageSize: 100 }'
            height='100%' 
            (toolbarClick)="toolbar.handleExport($event, grid)"
            [toolbar]="toolbarItens"

            [selectionSettings]="{enableToggle: false}"
            [allowFiltering]='false' 
            [allowSorting]='true' 
            [allowResizing]='true' 

            [showColumnChooser]='false'
            [showColumnMenu]='false'
           
            [allowExcelExport]='true'
            [allowPdfExport]='true'
            
            [contextMenuItems] = 'contextMenuItems'
            (contextMenuClick)='contextMenuClick($event)' 
            (contextMenuOpen) = 'onContextMenuOpen($event)'
            >
            <e-columns>
                <e-column field='statusTexto' [headerText]="'Status'" width='100'>
                    <ng-template #template let-data>
                        <app-appointment-status-tag [status]="data.statusId"></app-appointment-status-tag>
                    </ng-template>
                </e-column>
                <e-column headerText='Tipo' width='60' field='tipo'></e-column>
                <e-column field='data' [headerText]="'Data'" width='80'  [type]="'date'" [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column> 
                <e-column headerText='Paciente' field='pacienteNome'></e-column>
                <e-column field='estabelecimentoNomeFantasia' [headerText]="'Estabelecimento'" width='140'></e-column>
                <e-column field='cargoNome' [headerText]="'Cargo'" width='140'></e-column>
                <e-column headerText='Idade' width='40' field='pacienteIdade' [visible]="moreFields"></e-column>
                <e-column headerText='Sexo' width='40' field='pacienteSexo' [visible]="moreFields"></e-column> 
                <e-column headerText='Resultado' width='40' field='resultado' [visible]="true"></e-column> 
                <e-column field='modalide' [headerText]="'Modalide'" width='80'>
                    <ng-template #template let-data>
                        <app-appointment-modality-tag
                        [start]="data.horarioInicial"
                        [end]="data.horarioFinal" [schedulingId]="data.agendamentoId"
                        [remote]="data.remoto" 
                        [url]="data.urlAcesso"></app-appointment-modality-tag>
                    </ng-template>
                </e-column>
                <e-column headerText='Assinado' [textAlign]="'center'" width='40' field='assinou' type="boolean" [displayAsCheckBox]="true"></e-column>
                <e-column headerText='CPF' width='40' field='pacienteCpf'></e-column>
            </e-columns>

            <e-aggregates>
                <e-aggregate>
                    <e-columns>
                        <e-column field="id" type="count">
                            <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
            </e-aggregates>

        </ejs-grid>
    </ng-template>
</app-pesquisa-base>
